<div class="row filter-collapse" #filterCollapse>
    <div class="col-12">
        <div class="row">
            <div class="form-group col-12 col-md-4">
                <label for="situacaoFilter" class="col-form-label">Situação</label>
                <select class="form-control" name="situacaoFilter" id="situacaoFilter" 
                    [ngModel]="filter.situacao || ''" (ngModelChange)="filter.situacao = $event ? $event : null"
                    #situacao="ngModel">
                    <option value="">Todas as situações</option>
                    <option *ngFor="let situacao of situacoes" [ngValue]="situacao.id">{{situacao.nome}}</option>
                </select>                                       
            </div>                         
        </div>               
    </div>
</div>


